// ─── Angular Imports ───────────────────────────────────────────────────────────
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

// ─── Application Imports ───────────────────────────────────────────────────────
import { IProduct } from 'src/app/models/products/product';

@Component({
    selector: 'app-products-recent-section',
    templateUrl: './products-recent-section.component.html',
    styleUrls: ['./products-recent-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ProductsRecentSectionComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input() title!: string;
  @Input() products: IProduct[] = [];
  @Input() filter!: string;
  @Output() viewMore = new EventEmitter<string>();

  colPerScreen = 5;

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.breakpointObserver.observe([
      Breakpoints.XLarge,
      Breakpoints.Large,
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => {
      this.colPerScreen = this.calculateColPerScreen();
    });
  }

  calculateColPerScreen(): number {
    switch (true) {
      case this.breakpointObserver.isMatched(Breakpoints.XLarge):
        return 7;
      case this.breakpointObserver.isMatched(Breakpoints.Large):
        return 6;
      case this.breakpointObserver.isMatched(Breakpoints.Medium):
        return 5;
      case this.breakpointObserver.isMatched(Breakpoints.Small):
        return 3;
      case this.breakpointObserver.isMatched(Breakpoints.XSmall):
        return 2;
      default:
        return 1;
    }
  }
}
